import { PropsWithChildren } from "react";

import { FilterBar, Item } from "@bps/fluent-ui";

export interface RolloutPackageFilterValues {
  name: string;
}

interface RolloutPackageFilterProps extends PropsWithChildren<any> {
  setFilterArgs: React.Dispatch<
    React.SetStateAction<RolloutPackageFilterValues | undefined>
  >;
}

export const RolloutPackageFilter = ({
  children,
  setFilterArgs
}: RolloutPackageFilterProps) => {
  const filterItems: Item<RolloutPackageFilterValues>[] = [
    {
      name: "name",
      type: "searchBox",
      stickItem: true,
      props: { placeholder: "Search by name", removeSpecialCharacters: false }
    }
  ];

  return (
    <FilterBar<RolloutPackageFilterValues>
      items={filterItems}
      initialValues={{
        name: ""
      }}
      onChange={filter => setFilterArgs(filter.state.values)}
    >
      {children}
    </FilterBar>
  );
};
